import { FC, useState } from 'react'

import './style.scss'
import { Text, Button, Icon, useModal, Modal, FormMessageError, GridContainer, Spacer } from '../../UI'
import { CardFamilyMember } from './';

const FamilyGroup:FC<{ getFullname: (family: any) => string, onDelFamilyModal: (family: any) => void, data: any[] }> = ({ getFullname, onDelFamilyModal, data }) => {

  const OpenLightbox = () => {
    const coverLightbox = document.querySelector("#lightbox") as HTMLElement;
    if (coverLightbox) {
      coverLightbox.style.display = "block";
    }
  };

  const onAppointmentReserve = () => {
    (window as any).show_chat()
  }

  return (
    <>
      <GridContainer minWidthColumns='320px' maxWidthContainer='1200px'>
        {data && data.map((it: any) => {
          return (
            <CardFamilyMember
              it={it}
              key={it?.family_patient?.id}
              enableButtons={it.button_status}
              typeRelationship={it.type_relationship?.name}
              data={it.family_patient}
              onDelFamilyModal={onDelFamilyModal} 
              getFullname={getFullname} 
              onAppointmentReserve={onAppointmentReserve}
            />
          )
        })}
      </GridContainer>
    </>
  )
}

export { FamilyGroup }